/**
 *
 * Asynchronously loads the component for TaxpayerReport
 *
 */

import { lazyLoad } from 'utils/loadable';

export const TaxpayerReport = lazyLoad(
  () => import('app/modules/ManagementReport/TaxpayerReport/index'),
  (module) => module.TaxpayerReport
);
